import { useTranslation } from "react-i18next";
import moment from "moment";
import { useQuery, useSubscription } from "@apollo/react-hooks";
import "moment/locale/hu";
import { MY_TIME_GET_RECORDING_PERIOD } from "my-time/graphql/queries";
import { MY_TIME_SUBSCRIPTION } from "my-time/graphql/subscriptions";

export const useMyTimeRecordingPeriod = () => {
  const { data, loading, error, refetch } = useQuery(
    MY_TIME_GET_RECORDING_PERIOD,
    {
      fetchPolicy: "cache-and-network",
    },
  );

  useSubscription(MY_TIME_SUBSCRIPTION, {
    fetchPolicy: "network-only",
    onData: () => {
      refetch();
    },
  });

  const { i18n } = useTranslation();

  const recordingPeriod = data?.getRecordingPeriod || {};

  // Only create date if we have valid year and month
  if (!recordingPeriod?.year || !recordingPeriod?.month) {
    return {
      data: "",
      year: undefined,
      month: undefined,
      startDate: "",
      endDate: "",
      loading,
      error,
    };
  }

  const dateString = `${recordingPeriod.year}-${String(recordingPeriod.month).padStart(2, '0')}-15`;

  moment.locale(i18n.language);

  const dateMoment = moment(dateString, "YYYY-MM-DD");
  const monthTranslation = i18n.t(dateMoment.format("MMMM"));
  const date = `${dateMoment.format("YYYY.")} ${monthTranslation}`;

  return {
    data: date || "",
    year: recordingPeriod.year,
    month: recordingPeriod.month,
    startDate: dateMoment.startOf("month").format("YYYY-MM-DD"),
    endDate: dateMoment.endOf("month").format("YYYY-MM-DD"),
    loading,
    error,
  };
};

export default useMyTimeRecordingPeriod;
